import { render } from "./subcategorylist.vue?vue&type=template&id=6f155190"
import script from "./subcategorylist.vue?vue&type=script&lang=js"
export * from "./subcategorylist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__